export default __webpack_public_path__ + "static/media/fitt_hero.8772e475.mp4";